var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPeople = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.403,
  d: "M7.333 9.625v-.917A1.833 1.833 0 0 0 5.5 6.875H2.75A1.833 1.833 0 0 0 .917 8.708v.917M4.125 5.042a1.833 1.833 0 1 0 0-3.667 1.833 1.833 0 0 0 0 3.667M10.083 9.625v-.917a1.83 1.83 0 0 0-1.375-1.773M7.333 1.435a1.833 1.833 0 0 1 0 3.552"
})));
export default SvgPeople;